import React, { FC, useEffect, useState } from "react";
import { useMediaQuery, CircularProgress, Box } from "@mui/material";
import { type Theme } from "@mui/material/styles";
import { Navigate } from "react-router-dom";

import UserLayout from "./UserLayout";

import { useUserStore } from "@store/user";

interface PrivateLayoutContainerProps {
  noPadding?: boolean;
}

const PrivateLayoutContainer: FC<PrivateLayoutContainerProps> = ({ noPadding }) => {
  const isDesktop = useMediaQuery<Theme>(({ breakpoints }) => breakpoints.up("lg"));
  const [sidebarIsOpened, toggleSidebar] = useState<boolean>(true);
  const { user } = useUserStore();
  const [authChecked, setAuthChecked] = useState(false);

  const handleSidebarToggle = (): void => {
    toggleSidebar(!sidebarIsOpened);
  };

  useEffect(() => {
    toggleSidebar(isDesktop);
  }, [isDesktop]);

  useEffect(() => {
    const timer = setTimeout(() => {
      setAuthChecked(true);
    }, 500);

    return () => clearTimeout(timer);
  }, []);

  if (!authChecked) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  const params = new URLSearchParams(window.location.search);
  const urlToken = params.get("token");
  const accessToken = localStorage.getItem("access_token");

  if (!user && !urlToken && !accessToken) {
    const intendedUrl = window.location.pathname + window.location.search;

    sessionStorage.setItem("redirectAfterLogin", intendedUrl);

    return <Navigate to="/login" />;
  }

  return (
    <UserLayout
      {...{ handleSidebarToggle, sidebarIsOpened }}
      noPadding={noPadding}
    />
  );
};

export default PrivateLayoutContainer;
